import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function LegalCompliance() {
  const { data, siteNames } = useHSE();
  const rows = data.legalComplianceEvaluations || data.legalCompliance || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/legal-compliance", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `legal-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total Legal Obligations" value={rows.length} testid="lgl-total" />
      <StatCard label="Compliant" value={rows.filter((r) => r.complianceStatus === "compliant").length} tone="safe" />
      <StatCard label="Non-Compliant" value={rows.filter((r) => r.complianceStatus === "non_compliant").length} tone="critical" />
      <StatCard label="Under Review" value={rows.filter((r) => r.complianceStatus === "under_review").length} tone="warning" />
    </div>
  );

  return (
    <RegisterPage
      title="Legal & Regulatory Compliance"
      subtitle="ISO 45001 / ISO 14001 Clause 6.1.3 & 9.1.2 — Statutory Obligations, Regulations & Compliance Evaluations"
      storeKey="legalComplianceEvaluations"
      idPrefix="LGL"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "Legal ID" },
        { key: "jurisdiction", label: "Jurisdiction" },
        { key: "regulationName", label: "Regulation / Standard" },
        { key: "clauseReference", label: "Clause" },
        { key: "complianceStatus", label: "Status", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.complianceStatus === "compliant" ? "bg-emerald-100 text-emerald-800" : r.complianceStatus === "non_compliant" ? "bg-rose-100 text-rose-800" : "bg-amber-100 text-amber-800"}`}>{r.complianceStatus || "compliant"}</span> },
        { key: "nextEvalDate", label: "Next Evaluation" },
        { key: "actionId", label: "Linked CAPA Action", render: (r) => r.actionId ? <span className="font-mono text-[11px] text-[#18B84F]">{r.actionId}</span> : <span className="text-slate-300">—</span> },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Record ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "jurisdiction", label: "Jurisdiction", type: "select", options: ["KSA / MHRSD", "OSHA", "ISO Standard", "Civil Defense", "Environmental Ministry"] },
        { key: "regulationName", label: "Regulation / Legislation Title" },
        { key: "clauseReference", label: "Clause / Article Reference" },
        { key: "obligationSummary", label: "Obligation Requirement Summary", type: "textarea", full: true },
        { key: "ownerUserId", label: "Responsible Owner" },
        { key: "evaluationDate", label: "Evaluation Date", type: "date" },
        { key: "complianceStatus", label: "Compliance Evaluation", type: "select", options: ["compliant", "non_compliant", "under_review", "not_applicable"] },
        { key: "evidenceReference", label: "Evidence Reference Document" },
        { key: "reviewFrequencyMonths", label: "Review Frequency (Months)", type: "number" },
        { key: "nextEvalDate", label: "Next Evaluation Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["active", "superseded", "archived"] },
      ]}
    />
  );
}
